<template>
  <div id="dashboard" style="min-height: 650px;">
    <!-- Page Content -->
    <div class="content">
      <div class="block block-rounded block-bordered">
        <ul
          class="nav nav-tabs nav-tabs-block nav-main nav-main-horizontal nav-main-hover"
          data-toggle="tabs"
          role="tablist"
        >
          <li class="nav-item" v-for="(item,index) in bis" :key="index">
            <a
              class="nav-link"
              :class="item.BIS_TYPE == bisType ? 'active' + ' btabs-animated-fade-'+item.BIS_TYPE : 'btabs-animated-fade-'+item.BIS_TYPE "
              href="javascript:void(0)"
              @click="showTab('btabs-animated-fade-'+item.BIS_TYPE,item.BIS_TYPE)"
            >{{item.BIS_NAME}}</a>
          </li>

          <li class="ml-auto nav-main-item add"></li>

          <button
            type="button"
            class="btn-block-option"
            data-toggle="block-option"
            data-action="fullscreen_toggle"
            style="margin-right: 1.25rem"
          >
            <i class="si si-size-fullscreen"></i>
          </button>
        </ul>
        <div class="block-content tab-content overflow-hidden">
          <div class="tab-pane fade show active" id="btabs-animated-fade-1" role="tabpanel">
            <carportChargePackageList ref="carportChargePackageList"></carportChargePackageList>
          </div>
          <div class="tab-pane fade" id="btabs-animated-fade-2" role="tabpanel">
            <carportPackage ref="carportPackage"></carportPackage>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Util from "../../../../Util.js";
import carportChargePackageList from "./carportChargePackageList";
import carportPackage from "./carportPackage";

export default {
  name: "index",
  components: {
    carportChargePackageList,
    carportPackage
  },
  data() {
    return {
      bis: [
        {
          BIS_TYPE: "1",
          BIS_NAME: "充电时长包订单"
        },
        {
          BIS_TYPE: "2",
          BIS_NAME: "车棚时长包订单"
        }
      ],
      setToday: new Date(),
      starttime: "",
      endtime: "",
      page: 1,
      size: 10,
      total: 1,
      bisType: 1,
      pro: "",
      city: "",
      dis: "",
      edit: "",
      provinceList: [],
      cityList: [],
      districtList: [],
      cellList: [],
      carportList: [],
      carTypeList: [],
      form: {
        validTime: "",
        cellId: "",
        big_package_type: "",
        limit_duration: "",
        reset_hour: "",
        customName: "",
        carportId: "",
        carTypeId: "",
        sysDuration: "",
        payMoney: "",
        valIdTime: "",
        packageName: "",
        label: "",
        packageType: "",
        duration: "",
        authType: ""
      },
      addSystem: Util.isHavePerm("timeLen/addTimeLen"),
      addCarportSystem: Util.isHavePerm("carPort/insertCarportCarRate")
    };
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    roleName() {
      return this.$store.state.roleName;
    }
  },
  watch: {
    "$store.state.duration": {
      handler: function(val, oldVal) {
        if (typeof oldVal === "undefined") return;
        if (JSON.stringify(val) != JSON.stringify(oldVal)) {
          this.$refs.carportChargePackageList.getList();
          this.$refs.carportPackage.getList();
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {},
  methods: {
    changeTwoDecimal(val) {
      return Util.changeTwoDecimal(val);
    },

    showTab(el, type) {
      $(`.${el}`).tab("show");
      for (let i of $(`.tab-pane`)) {
        i.className = "tab-pane fade";
      }
      $(`#${el}`).tab("show");
      this.bisType = type;
      if (type == 1) {
        this.$refs.carportChargePackageList.getList();
      } else if (type == 2) {
        this.$refs.carportPackage.getList();
      }
    }
  }
};
</script>
